import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";

// Clickable column header for sortable tables (desktop).
export function SortHeader({ label, colKey, activeKey, dir, onSort, className = "" }) {
  const active = activeKey === colKey;
  const Icon = !active ? ChevronsUpDown : dir === "asc" ? ChevronUp : ChevronDown;
  return (
    <button
      type="button"
      onClick={() => onSort(colKey)}
      data-testid={`sort-${colKey}`}
      className={`data-label inline-flex items-center gap-1 hover:text-foreground transition-colors duration-150 cursor-pointer ${
        active ? "text-foreground" : ""
      } ${className}`}
    >
      {label}
      <Icon className={`h-3.5 w-3.5 ${active ? "" : "opacity-40"}`} />
    </button>
  );
}

// Compact sort control (field picker + direction toggle) usable on any viewport.
export function SortMenu({ options, sortKey, sortDir, onSortKey, onToggleDir, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="sort-menu">
      <Select value={sortKey} onValueChange={onSortKey}>
        <SelectTrigger className="bg-white gap-2 w-auto" data-testid="sort-field-select">
          <span className="text-muted-foreground text-xs whitespace-nowrap">Sortieren</span>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.key} value={o.key}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        type="button"
        variant="secondary"
        size="icon"
        onClick={onToggleDir}
        className="border border-border shrink-0"
        title={sortDir === "asc" ? "Aufsteigend" : "Absteigend"}
        data-testid="sort-direction-toggle"
      >
        {sortDir === "asc" ? (
          <ChevronUp className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
